var React = require('react');

function IconB3PlayerPlay (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("circle",{"opacity":"0.8","fill":"#FFFFFF","cx":"16","cy":"15.999","r":"16","key":0}),React.createElement("path",{"fill":"#3C3C3B","d":"M21.776,15.55l-8.634-5.593c-0.165-0.108-0.375-0.114-0.547-0.022c-0.171,0.094-0.28,0.275-0.28,0.471\n\t\tv11.185c0,0.198,0.109,0.379,0.28,0.472c0.079,0.043,0.168,0.065,0.256,0.065c0.101,0,0.203-0.028,0.291-0.086l8.634-5.593\n\t\tc0.153-0.099,0.244-0.269,0.244-0.45S21.928,15.649,21.776,15.55z","key":1})]));
}

IconB3PlayerPlay.displayName = "IconB3PlayerPlay";

IconB3PlayerPlay.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 32 32","enableBackground":"new 0 0 32 32","xmlSpace":"preserve"};

module.exports = IconB3PlayerPlay;

IconB3PlayerPlay.default = IconB3PlayerPlay;
